<template lang="html">
  <div v-if="servicenamechat !== 'Thewolf'" none class="cursorpointer" :style="'background-color: ' + backgroundText + '; height:30px; border-radius: 10px;'">
    <h4 class="centerDiv" style="color: white; margin-top: 5px !important;">แชทกับเจ้าหน้าที่ OSS</h4>
  </div>
</template>

<script>
const theme = require('../assets/theme')
export default {
  data: () => ({
    theme,
    servicenamechat: ''
  }),
  created () {
    // this.status_login = localStorage.getItem('status_login')
    this.servicenamechat = this.$route.params.servicename
    var servicename = this.$route.params.servicename
    // var concode = localStorage.getItem('con_code')
    // var tokenroom = localStorage.getItem('tokenroom')
    // if (this.status_login === 'T') {
    //   this.$router.push('/chat/' + servicename + '/' + concode + '/' + tokenroom)
    // }
    // if (this.theme[servicename].authen === this.$route.params.key) {
    this.backgroundText = this.theme[servicename].background
    // } else {
    //   this.backgroundText = '#01579b'
    // }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/MinChat.vue